import classes from "./VideoPlayer.module.css";
import ReactPlayer from "react-player";
import { useLocation, useNavigate } from "react-router-dom";
import svgBack from "../../assets/SVGs/back.svg";

function VideoPlayer() {
  const location = useLocation();
  const navigate = useNavigate();
  const fileAddress = location.state?.Address;
  const fileType = "video/mp4";
  var runonce = false;
  window.onpopstate = () => {
    if (!runonce) {
      navigate(-1);
      runonce = true;
    }
  };

  if (!fileAddress) {
    return <div>Error: No video URL provided</div>;
  }

  const handleContextMenu = (e) => {
    e.preventDefault();
  };

  const videoConfig = {
    file: {
      attributes: {
        controlsList: "nodownload",
        onContextMenu: handleContextMenu,
        playsInline: true,
      },
    },
  };

  return (
    <div className={classes.main}>
      <div className={classes.header}>
        <div className={classes.return} onClick={() => navigate(-1)}>
          <img src={svgBack} className={classes.svg} alt="Back" />
        </div>
      </div>
      <div
        style={{
          margin: "20px auto 0px auto",
          border: "5px solid #182d7a",
          borderRadius: "7px",
          maxWidth: "90%",
          boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
        }}
      >
      <ReactPlayer
        controls
  muted
  url={fileAddress}
  width="100%"
  config={{
    file: {
      attributes: {
        controlsList: "nodownload",
        onContextMenu: (e) => e.preventDefault(),
        playsInline: true,
      },
    },
  }}
  onContextMenu={(e) => e.preventDefault()}
/>

      </div>
    </div>
  );
}

export default VideoPlayer;
